import { makeStyles } from 'tss-react/mui';

const name = 'LockedTab';

export const useLockedTabStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),

    color: theme.palette.text.disabled,

    '&&&': {
      width: 'auto',
    },
  },
  lockIcon: {
    width: 20,
    height: 20,
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
  },
}));
